/**
 *
 * Asynchronously loads the component for SuccessPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SuccessPage = lazyLoad(
  () => import('./index'),
  module => module.SuccessPage,
);
